import styled from "styled-components";
import { BOX_SHADOW, PRIMARY, SECONDARY } from "../../const/colors";

export const ButtonSpecial = styled.button`
  font-size: 0.8rem;
  min-width: 130px;
  font-weight: 600;
	border: none;
  background-color: ${PRIMARY};
  color: ${SECONDARY};
  box-shadow: ${BOX_SHADOW};
  padding: 0.8rem 1.2rem;

  position: relative;
  cursor: pointer;

  transition: background-color .3s ease-in-out;
  span {
    z-index: 1;
  }

  &::before {
    content: "";
    width: 0%;
    height: 100%;
    position: absolute;
    background-color: #fff;
    left: 0;
    top: 0;
    z-index: -1;
    transition: 0.3s ease-in-out;
  }

  &:hover {
    background-color: transparent;
    color: #121212;
  }
  
  :hover::before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
  }

  
  @media screen and (max-width: 1200px) {
		font-size: .7rem;
	}

`;